// import { get } from 'lodash';
import apiConfig from '../../config/api_config';

export const casesApi = {
    getCases: (param) => apiConfig.get('/cases/', param),
    getMyCases: (param) => apiConfig.get('/cases/my_cases/', param),
    getCase:(id) => apiConfig.get(`/cases/${id}`),
    addCase: (data) => apiConfig.post('/cases/', data),
    acceptCase: (id) => apiConfig.post(`/cases/${id}/doctor_accept_case/`),
    rejectCase: (id) => apiConfig.post(`/cases/${id}/doctor_reject_case/`),
    assignDoctor: (caseId, doctorId) => apiConfig.post(`/cases/${caseId}/assign_doctor/`, { doctor_id: doctorId }),
    assignLab: (caseId, labId) => apiConfig.post(`/cases/${caseId}/assign_lab/`, { laboratory_id: labId }),
    resolveCase: (id) => apiConfig.post(`/cases/${id}/resolve_case/`),
    cancelCase: (id) => apiConfig.post(`/cases/${id}/farmer_cancel_case/`),
    reopenCase: (id) => apiConfig.post(`/cases/${id}/farmer_reopen_case/`),
    addNote: (caseId, data) => apiConfig.post(`/cases/${caseId}/add_note/`, data),
};